import { render, staticRenderFns } from "./Vertical.vue?vue&type=template&id=11fb1f50&scoped=true&"
import script from "./Vertical.vue?vue&type=script&lang=ts&"
export * from "./Vertical.vue?vue&type=script&lang=ts&"
import style0 from "./Vertical.vue?vue&type=style&index=0&id=11fb1f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fb1f50",
  null
  
)

export default component.exports